import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import './button.css';
import './CancelButton.css';
export const CancelButton = ({ onClick }) => {
    return (
        <Button
            onClick={onClick}
            className="cancel-button"
        >
            Cancel
        </Button>
    );
};

CancelButton.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default CancelButton;
